export class Person {
    id: number;
    username: string;
    fullName: string;
    email: string;
}

export class Schedule {
    id: number;
    author: Person;
    creationTimestamp: string;
    startTime: string;
    endTime: string;
}

export class ScheduleFlag {
    active: boolean = false;
    startTime: string = null;
    endTime: string = null;
}
